import { makeStyles } from '@mui/styles';
const selectionsStyles = makeStyles(({ palette: { text: { primary }, }, }) => ({
    details: {
        width: '100%',
    },
    subtext: {
        color: primary,
    },
}), { name: 'Common_Selections' });
export default selectionsStyles;
//# sourceMappingURL=selections.styles.js.map